/* eslint-disable */
import React, { useEffect } from 'react';
import { Box, List, ListItem, Card, CardContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataListRow from './dataListRow';
import { createTheme } from '@mui/material/styles';
import EnhancedTableToolbar from '../../../sharedcomponents/tableToolbar/tableToolbar';
import DraggableList from './draggableList';
import DetailsComponent from '../../../sharedcomponents/detailsComponent/DetailsComponent';
import { useEventState } from '../../../stores/eventStore';
import { useState } from '@hookstate/core';
import Title from '../../../sharedcomponents/title/title';
import Helper from '../../../utility/helper';
import WindowDataList from '../../../sharedcomponents/windowDataList/windowDataList';
import Paging from '../../../sharedcomponents/pagination/pagination';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    boxContent: {
        // paddingTop: theme.spacing(1),
    },
    listContent: {
        paddingBottom: theme.spacing(0),
        zIndex: 0,
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5)
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
}));

const DataList = (props) => {
    const classes = useStyles();
    const [listData, setListData] = React.useState([]);
    const [allListData, setAllListData] = React.useState([]);
    const [filterListData, setFilterListData] = React.useState(null);
    const [filterRoleNames, setFilterRoleNames] = React.useState([]);
    const [filterTagNames, setFilterTagNames] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [showToolbar, setShowToolbar] = React.useState(true);
    const eventState = useEventState();
    const moduleIndex = useState(-1);
    const userInfo = Helper.getStorage('userInfo');
    const [hotelRoomTaxID, setHotelRoomTaxID] = React.useState({
        index: '',
        value: 0,
    });

    const info = Helper.getStorage('eventInfo');

    useEffect(() => {
        setListData(props.data);
        rolesAndTagsCount(props.data)
        if (props.allData) {
            setAllListData(props.allData)
        }
        if (!props.showSearchRec) {
            setFilterListData(props.data);
        }
        // code to hide top toolbar
        if (props.showTopbar != undefined && !props.showTopbar) {
            setShowToolbar(props.showTopbar);
        }

        if (
            eventState &&
            eventState.eventDetail.get() != null &&
            props.moduleToShow != undefined
        ) {
            getModuleDetailsData();
        }
    }, [props]);

    const getModuleDetailsData = () => {
        // added for showing hotel module information in all star hotel module might need to change it for draft hotel
        const moduleToShow = props.moduleToShow === "Player Hotel" ? "AllStarHotel" : props.moduleToShow;
        const index = eventState.eventDetail
            .get()
            .moduleDetails.findIndex((element) => {
                // console.log(props.moduleToShow)
                if (
                    element.moduleName ===
                    (props.titleHeader ? props.titleHeader : moduleToShow)
                ) {
                    return true;
                }
            });
        if (!Helper.isAdminUser(userInfo)) {

            moduleIndex.set(index);
        }
    };

    // this need to be modified
    const handleFilterChangeValue = (filterObj) => {
        let modifyList = listData.filter((item) => {
            const data = item.actualData;
            if (filterObj) {
                return Object.keys(filterObj).every((filter) => {
                    let val =
                        typeof filterObj[filter] === 'string' &&
                            filter === 'transportType'
                            ? filterObj[filter].toLowerCase()
                            : filterObj[filter];
                    return val.includes(data[filter]);
                });
            }
        });

        if (filterObj) {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(true);
            }
            setFilterListData(modifyList);
            props.filterListData(modifyList);
        } else {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(false);
            }
            setFilterListData(listData);
            if (props.filterListData) props.filterListData(listData);
        }
    };

    const handleOnChange = (event) => {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        if (value.length > 0) {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(true);
            }
            let modifyList = [];
            let finalData = allListData.length > 0 ? allListData : listData;
            finalData.forEach((item) => {
                let data = item.actualData;
                let keys = Object.keys(data);
                keys.forEach((key) => {
                    if (
                        typeof data[key] === 'string' &&
                        data[key].toLowerCase().indexOf(value.toLowerCase()) >
                        -1
                    ) {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                });
            });
            rolesAndTagsCount(modifyList)
            setFilterListData(modifyList);
            if (props.filterListData) props.filterListData(modifyList);
        } else {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(false);
            }
            rolesAndTagsCount(listData)
            setFilterListData(listData);
            if (props.filterListData) props.filterListData(listData);
        }
    };
    const rolesAndTagsCount = (data) =>{
        let roleName = [];
        let tagName = []
         data &&  data.length > 0 && data.map((value) => {
            if(value.actualData.userTags !== "" || value.actualData.userTags !== null){
                let splitTags = value.actualData.userTags?.split(',') 
                if(splitTags && splitTags.length > 0) {
                    splitTags.map((value) => {
                        tagName.push({
                            tags: value.trim()
                        }) 
                    })
                    
                }
            }
            if(value.actualData.roleName !== ''){
                roleName.push({
                    name: value.actualData.name,
                    roleName: value.actualData.roleName, 
                })
            }
        })
        var reduceRoleName = roleName && roleName.length > 0 && roleName.reduce( (a,b) => {
            var i = a.findIndex( x => x.roleName === b.roleName);
            return i === -1 ? a.push({ roleName : b.roleName, times : 1 }) : a[i].times++, a;
        }, []);
        var reduceTags = tagName && tagName.length > 0 && tagName.reduce( (a,b) => {
            var i = a.findIndex( x => x.tags === b.tags);
            return i === -1 ? a.push({ tags : b.tags.trim(), times : 1 }) : a[i].times++, a;
        }, []); 
        setFilterRoleNames(reduceRoleName)
        setFilterTagNames(reduceTags)
        //  console.log("data",data,"tagName",tagName, roleName,reduceRoleName, reduceTags);
    }
    const onCheckSelect = (event, index) => {
        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.checked;
        setFilterListData(newFilterList);
    };
    const onCheckSelectAll = (event) => {
        let newFilterList = [...filterListData];
        newFilterList.forEach((item, index) => {
            if (props.showSendInvite && props.showSendInvite !== undefined) {
                if (item.actualData.email !== null) {
                    const nbaDomain = item.actualData.email.split('@');
                    // console.log("nbaDomain", nbaDomain[1]);
                    if (
                        item.actualData.registerDate === null &&
                        nbaDomain &&
                        nbaDomain[1] !== 'nba.com'
                    ) {
                        newFilterList[index]['selected'] = event.target.checked;
                    }
                }
            } else {
                newFilterList[index]['selected'] = event.target.checked;
            }
        });
        setFilterListData(newFilterList);
    };

    const onChangeHotelRoom = (event, index) => {
        setHotelRoomTaxID({
            ...hotelRoomTaxID,
            index: index,
            value: event.target.value,
        });
        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.value;
        setFilterListData(newFilterList);
    };

    const handleEditAll = () => {
        props.editAllToggle();
    };
    const handleHotelSave = () => {
        let newFilterList = [...filterListData];
        props.editAll(newFilterList);
    };

    return (
        <Box className={classes.boxContent}>
            {props.moduleToShow ? <Title title={props.moduleToShow} /> : null}
            {props.moduleToShow != undefined &&
                eventState.eventDetail.get() &&
                ((moduleIndex.get() >= 0 &&
                    eventState.eventDetail.get().moduleDetails[
                        moduleIndex.get()
                    ].details != null) ||
                    '') && (
                    <DetailsComponent
                        data={
                            eventState.eventDetail.get().moduleDetails[
                                moduleIndex.get()
                            ].details
                        }
                    />
                )}
            {showToolbar ? (
                <EnhancedTableToolbar
                    {...props}
                    search={search}
                    showSendAll={props.showSendAll ? true : false}
                    sendAllbuttonTitle={props.showSendAll ? 'Send All' : null}
                    showEdit={props.showEdit ? true : false}
                    showEdittags={props.showEdittags ? true : false}
                    showEditroles={props.showEditroles ? true : false}
                    editButtonTitle={props.showEdit ? true : false}
                    handleSearchChange={handleOnChange}
                    handleFilterChange={handleFilterChangeValue}
                    handleSendEmail={props.handleSendEmail}
                    hideAdd={props.hideAdd ? true : false}
                    modPermission={props.modPermission}
                    disableAdd={props.disableAdd}
                    onCheckSelectAll={onCheckSelectAll}
                    showEditHotel={props.showEditHotel ? true : false}
                    handleEditAll={handleEditAll}
                    showHotelToggle={props.showHotelToggle}
                    saveHotelButtonTitle={props.saveHotelButtonTitle}
                    handleHotelSave={handleHotelSave}
                    eventConfigStatus={props.eventConfigStatus}
                    compUsed={props.compUsed}
                    purchaseUsed={props.purchaseUsed}
                    readOnlyOrHide={info && info.readonlyOrHide}
                    filterRoleNames={filterRoleNames}
                    filterTagNames={filterTagNames}
                    moduleIndex={moduleIndex.get()}
                />
            ) : null}
            {props.isDraggable != undefined ? (
                <DraggableList
                    classes={classes}
                    data={filterListData}
                    onDragEnd={props.onDragEnd}
                    editRow={props.editRow}
                    modPermission={props.modPermission}
                    {...props}
                    showModuleSetting={props.showModuleSetting}
                    onModuleSettingClick={props.onModuleSettingClick}
                />
            ) : (
                // <List className={classes.listContent}>
                //     {filterListData && filterListData.length > 0 ? (
                //         filterListData.map((item, index) => (
                //             <DataListRow
                //                 key={`datarow_${index}`}
                //                 item={item}
                //                 index={index}
                //                 onCheckSelect={onCheckSelect}
                //                 editRow={props.editRow}
                //                 viewPage={props.viewPage}
                //                 onSwitchToggle={props.onSwitchToggle}
                //                 onActionClick={props.onActionClick}
                //             />
                //         ))
                //     ) : (
                //         <ListItem className={classes.listItemContent}>
                //             <Card
                //                 classes={{ root: classes.paperContent }}
                //                 sx={{ width: '100%' }}>
                //                 <CardContent
                //                     sx={{ p: 2 }}
                //                     className={classes.cardContent}>
                //                     <Box className={classes.rowContent}>
                //                         No data found
                //                     </Box>
                //                 </CardContent>
                //             </Card>
                //         </ListItem>
                //     )}
                // </List>
                <>
                    {props.windowDataList != undefined && props.windowDataList ?
                        (
                            filterListData && filterListData.length > 0 ? (
                                <WindowDataList
                                    data={filterListData}
                                    onCheckSelect={onCheckSelect}
                                    modPermission={props.modPermission}
                                    editRow={props.editRow}
                                    addConnection={props.addConnection}
                                    addConnectionLinkedWith={
                                        props.addConnectionLinkedWith
                                    }
                                    deleteConnection={props.deleteConnection}
                                    rowType={props.rowType}
                                    editTemplate={props.editTemplate}
                                    editSendEmail={props.editSendEmail}
                                    emailLoading={props.emailLoading}
                                    editLoading={props.editLoading}
                                />
                            ) : 
                            filterListData && filterListData.length == 0 ?
                                <List className={classes.listContent} sx={{paddingLeft: 1, paddingRight: 1}}>
                                    <ListItem className={classes.listItemContent}>
                                        <Card
                                            classes={{ root: classes.paperContent }}
                                            sx={{ width: '100%' }}>
                                            <CardContent
                                                sx={{ p: 2 }}
                                                className={classes.cardContent}>
                                                <Box className={classes.rowContent}>
                                                    No data found
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </ListItem>
                                </List>
                            : null
                        )
                        :
                        (
                            <List className={classes.listContent}>
                                {filterListData && filterListData.length > 0 ? (
                                    filterListData.map((item, index) => (
                                        <DataListRow
                                            {...props}
                                            key={`datarow_${index}`}
                                            item={item}
                                            index={index}
                                            onCheckSelect={onCheckSelect}
                                            onCheckSelectAll={onCheckSelectAll}
                                            editRow={props.editRow}
                                            editTemplate={props.editTemplate}
                                            editSendEmail={props.editSendEmail}
                                            viewPage={props.viewPage}
                                            onSwitchToggle={props.onSwitchToggle}
                                            onActionClick={props.onActionClick}
                                            onPendingAction={props.onPendingAction}
                                            addConnection={props.addConnection}
                                            addConnectionLinkedWith={
                                                props.addConnectionLinkedWith
                                            }
                                            deleteConnection={props.deleteConnection}
                                            modPermission={props.modPermission}
                                            copyToClipboard={props.copyToClipboard}
                                            outfitInfo={props.outfitInfo}
                                            onChangeHotelRoom={onChangeHotelRoom}
                                            hotelRoomTaxID={hotelRoomTaxID}
                                            hotelKeyValue={props.hotelKeyValue}
                                            readOnlyOrHide={info && info.readonlyOrHide}
                                        />
                                    ))
                                ) : (
                                    filterListData && filterListData.length == 0 ? 
                                        <ListItem className={classes.listItemContent}>
                                            <Card
                                                classes={{ root: classes.paperContent }}
                                                sx={{ width: '100%' }}>
                                                <CardContent
                                                    sx={{ p: 2 }}
                                                    className={classes.cardContent}>
                                                    <Box className={classes.rowContent}>
                                                        No data found
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </ListItem>
                                    : null
                                )}
                            </List>
                        )}
                </>
            )}

            {props.pagingInfo &&
                props.pagingInfo.noOfPages > 1 &&
                !props.showSearchRec ? (
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Paging
                        pagingInfo={props.pagingInfo}
                        handlePageChange={props.handlePageChange}
                    />
                </Box>
            ) : null}
        </Box>
    );
};

export default DataList;
